import { faCheck, faExclamation, faX } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal, ModalContent } from '@pickleballinc/react-ui';

interface NoEventsModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	title: string;
	message?: string;
	confirmButtonText?: string;
	confirmButtonVariant?: 'blue' | 'secondary';
	doNotShowCloseButton?: boolean;
	iconColor?: string;
	showSuccessIcon?: boolean;
}

const NoEventsModal = ({
	open,
	onClose,
	onConfirm,
	title,
	message,
	confirmButtonText = 'Ok',
	confirmButtonVariant = 'blue',
	doNotShowCloseButton = false,
	iconColor = 'error-500',
	showSuccessIcon = false
}: NoEventsModalProps) => {
	return (
		<Modal open={open} onOpenChange={onClose}>
			<ModalContent className="flex w-[calc(100%-16px)] flex-col gap-4 !overflow-hidden !p-6 !outline-none md:max-w-[430px]">
				<div className="relative text-center">
					<div
						className="absolute -right-2 top-0 flex size-6 items-center justify-center rounded-md border border-solid border-gray-300 bg-white p-1 hover:cursor-pointer hover:bg-gray-100"
						onClick={onClose}
					>
						<FontAwesomeIcon icon={faX} className="text-gray-400" height={20} />
					</div>

					<div className={`${`border-${iconColor}`} mx-auto flex size-16 items-center justify-center rounded-full border-4 md:size-24`}>
						<FontAwesomeIcon icon={showSuccessIcon ? faCheck : faExclamation} className={`text-${iconColor}`} size="3x" />
					</div>
				</div>
				<div className="flex flex-col gap-2">
					<div className="text-center text-xl font-semibold md:text-2xl">{title}</div>
					{message && <div className="text-center text-sm md:text-base">{message}</div>}
				</div>
				<div className={`flex items-center gap-4 ${!doNotShowCloseButton ? 'justify-between' : 'justify-center'}`}>
					{!doNotShowCloseButton && (
						<Button
							variant="secondary"
							className="flex w-[150px] justify-center border !text-sm !text-gray-500 focus:!shadow-[unset]"
							onClick={onClose}
						>
							Close
						</Button>
					)}
					<Button
						variant={confirmButtonVariant}
						className="flex w-[250px] justify-center !text-sm focus:!shadow-[unset]"
						onClick={onConfirm}
					>
						{confirmButtonText}
					</Button>
				</div>
			</ModalContent>
		</Modal>
	);
};

export default NoEventsModal;
